require('./bootstrap')

import {App, Head, plugin} from '@inertiajs/inertia-vue3'
import InertiaLink from '@/Components/Shared/InertiaLink'
import {createApp, h} from 'vue'
import store from './store'
import route from 'ziggy'
import translate from './translate'
import {debounce} from './global'
import {InertiaProgress} from '@inertiajs/progress'
import Layout from '@/Layouts/App'
import * as Sentry from '@sentry/vue'
import { Userpilot } from 'userpilot'

const {RayPlugin} = require('vue-ray')

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,

    // The color of the progress bar.
    color: '#942FEA',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: true,
    height: '4px'
})

const el = document.getElementById('app')

const app = createApp({
    render: () =>
        h(App, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name =>
                import(`./Pages/${name}`).then(({default: page}) => {
                    if (page.layout === undefined) {
                        page.layout = Layout
                    }
                    return page
                })
        })
})

app.mixin(translate)

app.directive('debounce', {
    mounted(el, binding) {
        if (binding.value !== binding.oldValue || binding.value === undefined) {
            el.oninput = debounce(function (e) {
                el.dispatchEvent(new CustomEvent('debounced', {detail: e.target.value}))
            }, parseInt(binding.value) || 500)
        }
    }
})

app.config.globalProperties.$filters = {
    currencyUSD(value) {
        return '$' + value
    },
    truncate(text, length, clamp) {
        clamp = clamp || '...'
        var node = document.createElement('div')
        node.innerHTML = text
        var content = node.textContent
        return content.length > length
            ? content.slice(0, length) + clamp
            : content
    }
}

app.use(plugin)
    .use(store)
    .component('InertiaHead', Head)
    .component('InertiaLink', InertiaLink)

if (process.env.MIX_RAY_ENABLED) {
    let rayPort = process.env.MIX_RAY_PORT || 23517
    let rayIP = process.env.MIX_RAY_IP || '127.0.0.1'
    let rayInterceptErrors = process.env.MIX_RAY_INTERCEPT_ERRORS || false
    app.use(RayPlugin, {interceptErrors: rayInterceptErrors, host: rayIP, port: rayPort})
}

Sentry.init({
    app,
    dsn: 'https://4eaed1d22e6648bf80e63ec311dbd079@o500851.ingest.us.sentry.io/5581250',
    integrations: [
        Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
})

app.mount(el)
app.config.globalProperties.$route = route

Userpilot.initialize('STG-NX-d299a188')
